/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  getKey.ts
 */

import { EnhancedStorageOptions } from '../types/EnhancedStorageOptions'

import { getKeySeparator } from './getKeySeparator'

export const getKey = (storageKey: string, options: EnhancedStorageOptions) => {
  const prefix = `${options.name}${getKeySeparator(options)}`
  if (storageKey.startsWith(prefix)) {
    return storageKey.slice(prefix.length)
  }
  // TODO: what do we really expect here?
  return storageKey
}
